import styled, { css } from 'styled-components';

export const PhoneNumberLabel = styled.div`
  color: ${({ isError, theme }) =>
    isError ? theme.COLORS.ERROR : theme.COLORS.BASE_INVERTED};
`;

const PhoneNumberInputVariants = {
  error: css`
    border: 2px solid ${({ theme }) => theme.COLORS.ERROR};
  `,
  noError: css`
    border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_20};
    margin-bottom: 2px;
  `
};

export const PhoneNumberInput = styled.input`
  margin-top: 6px;
  width: 291px;
  border-radius: 3px;
  padding: 8px;
  ${({ isError }) =>
    isError ? PhoneNumberInputVariants.error : PhoneNumberInputVariants.noError}
  ::placeholder {
    color: ${({ theme }) => theme.COLORS.NEUTRAL_20};
    font-style: normal;
  }
  &:focus {
    outline: none;
  }
  @media only screen and (max-width: ${({ theme }) =>
      theme.BP.TIAH_DETAILS_WIDTH}) {
    width: 100%;
  }
`;
